import type { HomeCardLayout } from "@/campaigns";
import type { PrizeDrop } from "@/campaigns/modules/prizedrop/types";

import { CompactCampaignCard } from "@/components/campaign-card/campaign-card-compact";
import { Gift } from "lucide-react";
import { formatPrizeTitle } from "@/utils/helpers";
import {
  topDroppingPrize,
  totalRemaining,
} from "@/campaigns/modules/prizedrop/types";
import { useTranslation } from "react-i18next";

export const PrizeDropHomeCard = ({
  prizeDrop,
  layout,
}: {
  prizeDrop: PrizeDrop;
  layout: HomeCardLayout;
}) => {
  const { t } = useTranslation();
  const top = topDroppingPrize(prizeDrop);
  const remaining = totalRemaining(prizeDrop);

  return (
    <CompactCampaignCard
      campaign={prizeDrop.campaign}
      typeLabel={t("campaign.typePrizeDrop", "Prize drop")}
      typeIcon={<Gift />}
      hookValue={top ? formatPrizeTitle(top.label, t) : null}
      hookLabel={t("campaign.topPrize", "Top prize")}
      hookIsCatalogItem={top?.is_catalog_item}
      metaExtra={
        remaining > 0
          ? t("prizedrop.prizesLeft", "{{amount}} prizes left", {
              amount: remaining,
            })
          : undefined
      }
      layout={layout}
    />
  );
};
